import { Component } from 'src/utils';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import template from './order-detail.html';

@Component({
  controllerAs: 'orderDetail',
  template
})

export default class OrderDetail {
  static $inject = [
    '$scope',
    '$ngRedux',
    '$state',
    '$stateParams',
    'toaster',
    'authService',
    'spinnerService',
    '$q',
    'orderService',
    '$timeout',
    '$cookies',
    '$window',
    'APP',
    '$rootScope',
    'POWERREVIEWS'
  ];

  constructor($scope, $ngRedux, $state, $stateParams, toaster, $auth, $spinner, $q, $order, $timeout, $cookies,$window, APP, $rootScope, POWERREVIEWS) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    this.$stateParams = $stateParams;
    this.$order = $order;
    this.toaster = toaster;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.$auth = $auth;
    this.APP = APP;
    this.$state = $state;
    this.$window = $window;
    this.dscMasterCode = '88888888'; // Named constant
    this.isCardSaved = $stateParams.isCardSaved;
    this.isGuestLogin = $auth.isGuestLogin();
    this.$rootScope = $rootScope;
    this.POWERREVIEWS = POWERREVIEWS;
    let orderSummaryPromise = $order.getOrderSummary($stateParams.orderId)
      .catch(() => $state.go('payment.failure'));
    let userProfilePromise = this.isGuestLogin ? $auth.getGuestUserProfile() : $auth.getUserProfile();
    if (this.isGuestLogin) {
      this.$rootScope.inOrderPage = true;
      const guestUserDetails = sessionStorage.getItem('guestUserDetails') ? JSON.parse(sessionStorage.getItem('guestUserDetails')) : null;
      if (guestUserDetails && guestUserDetails.email) {
        this.$rootScope.guestCheckoutEmail = guestUserDetails.email;
      }
    } else {
      this.$rootScope.inOrderPage = false;
      this.$rootScope.guestCheckoutEmail = null;
    }
    $spinner.show('appSpinner');
    let promises = [orderSummaryPromise, userProfilePromise];
    $q.all(promises).finally(() => {
      if (this.isGuestLogin) {
        this.profile = this.guestprofile;
        sessionStorage.setItem('guestOrderCheckedOut', true);
      }
      this.gaTransactionDetails($window);
      $spinner.hide('appSpinner');
      sessionStorage.removeItem('guestoauth');
      sessionStorage.removeItem('isGuestUserLoggedIn');
      $cookies.remove('guestCart');
      $cookies.remove('GuestCartRequest');
      $rootScope.guestUserDetails = null;
      $auth.removeGuestCart();
      if (this.isGuestLogin) {
        let count = 0;
        while ($cookies.get('guestCart')) {
          if (count < 5) {
            count++;
            $auth.removeGuestCart();
          } else {
            return;
          }
        }
      }
    });

    localStorage.removeItem('deliveryAddress');

    try {
          sessionStorage.removeItem('discountCoupon');
          sessionStorage.removeItem('discountCouponAmount');
          sessionStorage.removeItem('birdbuckCoupon');
          sessionStorage.removeItem('erplyBBDiscount');
          sessionStorage.removeItem('erplyBBCouponCodes');
          sessionStorage.removeItem('erplyPromotionCodes');
          sessionStorage.removeItem('erplyPromotionDiscount');
          sessionStorage.removeItem('orderNotesSession');
        }
        catch (e) {
          $cookies.remove('discountCouponAmount');
          $cookies.remove('discountCoupon');
          $cookies.remove('birdbuckCoupon');
          $cookies.remove('erplyBBDiscount');
          $cookies.remove('erplyBBCouponCodes');
          $cookies.remove('erplyPromotionCodes');
          $cookies.remove('erplyPromotionDiscount');
          $cookies.remove('orderNotesSession');
        }

    this.currencyType = 'USD';
    $timeout(() => {
    this.country = this.profile.store.country.countryCode?this.profile.store.country.countryCode:'US';
    
      if(this.profile.store){
        // console.log(this.profile);
        this.currencyType=$order.getCurrencyType(this.country);
      }
    },800);
    $rootScope.curbSideDetails = null;
    $rootScope.tempdeliveryMode = null;
    $rootScope.isCurbside = null;
    $scope.$on('$destroy', () => {
      this.$rootScope.inOrderPage = false;
    });
  }

  mapState(state) {
    return {
      profile: state.auth.profile,
      summary: state.order.orderDetail,
      guestprofile: state.auth.guestprofile
    };
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  formattedTime(dateTime) {
    const date = dateTime ? new Date(dateTime) : new Date();
    const hours = date.getHours() <= 12 ? date.getHours() : date.getHours() - 12;
    let time = (hours < 10 ? `0${hours}` : hours) + ':' +
      (date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes());
    const ampm = date.getHours() >= 12 ? ' PM' : ' AM';
    return time + ampm;
  }

  saveCardDetail() {
    this.$order.saveCardDetail(this.$stateParams.orderId)
      .then(success => this.toaster.pop('success', success.data.message))
      .catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      });
  }

  getDSCDiscount() {
    if (this.profile.customer && (this.profile.customer.dscId === 'C' &&
      new Date() <= new Date(this.profile.customer.dscExpireDate))) {
      let dscItems = this.summary.orderEntries &&
      this.summary.orderEntries.filter(item => item.subCategory.category.dscCategory);
      let totalPrice = dscItems && dscItems.map(item => item.item.price * item.quantity)
        .reduce((prev, curr) => prev + curr, 0);
      return totalPrice * 15 / 100;
    }
    return 0;
  }

  isDscMember() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
  }

  isDscButExpired() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
  }

  calculateTotalWeight() {
    var weightsArray = [];
    if (this.summary.orderEntries && this.summary.orderEntries.length){
    weightsArray = this.summary.orderEntries.map(totalWeight => totalWeight.quantity * totalWeight.item.weight);
    }
    let totalWeight = 0;
    for (var i = 0; i < weightsArray.length; i++) {
      totalWeight += weightsArray[i];
    }
    return totalWeight;
  }

  calculateTotalProductWeight(quantity, weight) {
    return quantity * weight;
  }

  cartContainsOnlyDsc() {
    const dscIsInCart = (this.summary.orderEntries.filter(item => item.item.masterProduct.masterCode === this.dscMasterCode)).length;
    const totalItemsInCart = this.summary.orderEntries.length;
    return dscIsInCart && (totalItemsInCart === dscIsInCart);
  }

  subscribeNow(order){
  this.$auth.resetSubscriptionCart();
  this.$state.go('subscription-detail',{subscriptionId:order.orderId,option:'add'});
  }

  gaTransactionDetails($window){
    console.log("Sending transaction details to GA");
    console.log("Order", this.summary);
    var orderEntries = [];
    if(this.summary){
      if($window.ga){
      $window.ga('require', 'ecommerce');

      var gaTransaction = {
        'id': this.summary.orderId,                                               // Transaction ID. Required.
        'affiliation': '',                                                        // Affiliation or store name.
        'revenue': this.summary.amountPaid,                                       // Grand Total.
        'shipping': this.summary.shippingCharge - this.summary.shippingDiscount,  // Shipping.
        'tax': this.summary.orderTax                                              // Tax.
      };

      $window.ga('ecommerce:addTransaction', gaTransaction);
      
        orderEntries = this.summary.orderEntries;
      var categoryName = '';
      
      console.log(orderEntries);
      // Adding items
      orderEntries.forEach(order => {
        console.log("Order Detail",order);
        if(order.subCategory){
          categoryName = order.subCategory.category.name + " : " + order.subCategory.name;
        } else {
          categoryName = order.subCategory.category.name; 
        }
        var gaItem = {
          'id': this.summary.orderId,                     // Transaction ID. Required.
          'name': order.item.name,                        // Product name. Required.
          'sku': order.item.masterProduct.masterCode,     // SKU/code.
          'category': categoryName,                       // Category or variation.
          'price': order.price,                           // Unit price.
          'quantity': order.quantity
        };
        $window.ga('ecommerce:addItem', gaItem);
        gaItem = {};
        categoryName = '';
      });

      // Adding BirdBucks if any as an item
      if(this.summary.appliedBBCoupon){
        var bbItem = {
          'id': this.summary.orderId,                     
          'name': 'BirdBuck coupon',                        
          'sku': this.summary.appliedBBCoupon,     
          'category': 'BirdBuck coupon',                      
          'price': -this.summary.appliedBBCouponAmount,                           
          'quantity': 1
        };
        $window.ga('ecommerce:addItem', bbItem);
      }

      // Adding discounts if any as an item
      if(this.summary.appliedDiscountCoupon){
        var discountAmount = this.summary.appliedDiscountCouponAmount?this.summary.appliedDiscountCouponAmount:0;

        var promoItem = {
          'id': this.summary.orderId,                     
          'name': 'Promo code',                        
          'sku': this.summary.appliedDiscountCoupon,   
          'category': 'Promo code : ' + this.summary.appliedDiscountType,                       
          'price': -discountAmount,                           
          'quantity': 1
        };
        $window.ga('ecommerce:addItem', promoItem);
      }
      $window.ga('ecommerce:send');
    }
  }
    if($window.pwr){
      if(this.summary){
        try{
          console.log("Order Power review", this.summary);
          orderEntries = this.summary.orderEntries;
          var pwrOrderItems = [];
          var pwrItem = {};
            // Adding items
            orderEntries.forEach(order => {
              pwrItem = {                   
                'product_name': order.item.name,                       
                'page_id': order.item.masterProduct.masterCode.substring(0, 7),                    
                'unit_price': order.price,                           
                'quantity': order.quantity
              };
              if(order.item.weight){
                pwrItem.page_id_variant = order.item.weight;
              }
              pwrOrderItems.push(pwrItem);
            });
          var tracker = this.POWERREVIEWS.tracker.createTracker({
              merchantGroupId: this.APP.AUTH.AUTH_URL.pwr.merchant_group_id});
          var orderFeed = {
                  merchantGroupId: this.APP.AUTH.AUTH_URL.pwr.merchant_group_id,
                  merchantId: this.APP.AUTH.AUTH_URL.pwr.merchant_id,
                  locale: this.APP.AUTH.AUTH_URL.pwr.locale,
                  merchantUserId: this.summary.user.userId,
                  marketingOptIn: true,
                  userEmail: this.summary.user.email,
                  userFirstName: this.summary.user.customer.firstName,
                  userLastName: this.summary.user.customer.lastName,
                  orderId: this.summary.orderId,
                  orderItems: pwrOrderItems
              };
              console.log("Pwr final rview : ", orderFeed);
              tracker.trackCheckout(orderFeed);
        }catch(e){
          $window.console && $window.console.log(e);
        }
      }
    }
    console.log("$Window check for pwr : ", $window);
  }

  infoPopup() {
    document.getElementById('popup').style.display = 'block';
    setTimeout(() => {
     if (document.getElementById('popup').style.display === 'block' && this.showPopup === false) {
      this.hideinfoPopup();
     }
     }, 5000);
  }
  hideinfoPopup() {
    document.getElementById('popup').style.display = 'none';
    this.showPopup = false;
  }
  infoPopuponhover() {
    document.getElementById('popup').style.display = 'block';
    this.showPopup = true;
  }
  infoPopupFee() {
    document.getElementById('popup1').style.display = 'block';
    setTimeout(() => {
     if (document.getElementById('popup1').style.display === 'block' && this.showPopupFee === false) {
      this.hideinfoPopupFee();
     }
     }, 5000);
  }
  hideinfoPopupFee() {
    document.getElementById('popup1').style.display = 'none';
    this.showPopupFee = false;
  }
  infoPopuponhoverFee() {
    document.getElementById('popup1').style.display = 'block';
    this.showPopupFee = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/order/payment/order-detail.js